import { render, staticRenderFns } from "./CreateCaregiverDialog.vue?vue&type=template&id=32bb008f&"
import script from "./CreateCaregiverDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCaregiverDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports